import { AuthInProgress } from 'shared/providers';
import { InteractionType } from '@azure/msal-browser';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsalAuthentication } from '@azure/msal-react';
import { NoPropsJustChildren } from 'shared/types';

export function AuthenticationRequired({ children }: NoPropsJustChildren) {
    useMsalAuthentication(InteractionType.Redirect);
    return (
        <>
            <AuthenticatedTemplate>{children}</AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                <AuthInProgress />;
            </UnauthenticatedTemplate>
        </>
    );
}
